import { skipToken } from '@reduxjs/toolkit/query'
import { useMemo } from 'react'
import { useGetExperienceValidDatesQuery } from '../store'

export enum DateStatus {
  NOT_AVAILABLE = 0,
  REQUESTABLE = 1,
  BOOKABLE = 2,
}

interface useExperienceValidDatesProps {
  venueUrlKey: string
  startDate: string
  selectedDate?: string
  partySize: number
  experienceUrlKey: string
  availabilityCacheDays?: number
  skipRequests?: boolean
  includeStartDate?: boolean
}

export function useExperienceValidDates({
  venueUrlKey,
  startDate,
  selectedDate,
  partySize,
  experienceUrlKey,
  availabilityCacheDays,
  includeStartDate,
  skipRequests,
}: useExperienceValidDatesProps) {
  const { data, isLoading, isFetching, isError } = useGetExperienceValidDatesQuery(
    skipRequests
      ? skipToken
      : {
          venue: venueUrlKey,
          startDate,
          experienceUrlKey,
          availabilityCacheDays,
        }
  )
  const firstAvailableDayForBooking = useMemo(
    () =>
      data
        ? Object.entries(data)
            ?.sort((entry1, entry2) => new Date(entry1[0]).getTime() - new Date(entry2[0]).getTime())
            .find(([date, availability]) => {
              if (
                selectedDate &&
                (new Date(date).getTime() < new Date(selectedDate).getTime() ||
                  (!includeStartDate && new Date(date).getTime() <= new Date(selectedDate).getTime()))
              ) {
                return false
              }
              if (availability[partySize] === DateStatus.BOOKABLE) {
                return date
              }
              return false
            })?.[0]
        : undefined,
    [data, includeStartDate, partySize, selectedDate]
  )

  return {
    data: {
      availability: data,
      firstAvailableDayForBooking,
    },
    isLoading,
    isFetching,
    isError,
  }
}
